let uid = 0

export default {
    name: "SchemaMarkupDate",

    props: {
        modelValue: { type: String, default: "" },
        label: { type: String, default: "" },
        format: { type: String, default: "dd-MM-yyyy" },
        readonly: { type: Boolean, default: false }
    },

    emits: ["update:modelValue"],

    setup(props, { emit }) {
        const fieldId = `kb-date-${++uid}`
        const onInput = (event) => emit("update:modelValue", event.target.value)
        return { fieldId, onInput }
    }
}
